import dayjs, { extend } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

extend(relativeTime);

/**
 * Formats a date for activity display in CRM/pipeline views.
 * - Shows relative time for items < 7 days ("2 hours ago", "3 days ago")
 * - Shows exact date for older items ("Dec 15", "Nov 28")
 */
export const formatActivityDate = (date: string | Date | null | undefined): string | null => {
  if (!date) return null;
  const parsed = dayjs(date);
  if (!parsed.isValid()) return null;

  const daysDiff = dayjs().diff(parsed, 'day');
  if (daysDiff < 7) {
    return parsed.fromNow();
  }
  return parsed.format('MMM D');
};

/**
 * Formats a date for email display with full details.
 * Example: "Sat, Jan 15, 2024, 10:30 AM"
 */
export const formatEmailDate = (date: Date | string | undefined): string => {
  if (!date) return '';
  const parsed = dayjs(date);
  if (!parsed.isValid()) return '';
  return parsed.format('ddd, MMM D, YYYY, h:mm A');
};
